import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "open-instruction" }, "Instruction for eSIM activation", -1)
const _hoisted_2 = {
  class: "button-toggle-group",
  style: {"margin-left":"30px"}
}

import { ref, Ref } from "vue";
import { Esim } from "@/stores/esim";
import ActivationIos from "@/components/esim/activation/ActivationIos.vue";
import ActivationAndroid from "@/components/esim/activation/ActivationAndroid.vue";

enum InstructionType {
  Ios,
  Android,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EsimActivation',
  props: {
  esim: Esim,
},
  setup(__props) {



const currentInstruction: Ref<InstructionType> = ref(InstructionType.Ios);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["button-toggle", { active: currentInstruction.value === InstructionType.Ios }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (currentInstruction.value = InstructionType.Ios))
      }, " iOS ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["button-toggle", { active: currentInstruction.value === InstructionType.Android }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (currentInstruction.value = InstructionType.Android))
      }, " Android ", 2)
    ]),
    (currentInstruction.value === InstructionType.Ios)
      ? (_openBlock(), _createBlock(ActivationIos, {
          key: 0,
          esim: __props.esim
        }, null, 8, ["esim"]))
      : _createCommentVNode("", true),
    (currentInstruction.value === InstructionType.Android)
      ? (_openBlock(), _createBlock(ActivationAndroid, {
          key: 1,
          esim: __props.esim
        }, null, 8, ["esim"]))
      : _createCommentVNode("", true)
  ]))
}
}

})